"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var operators_1 = require("rxjs/operators");
var datetime_1 = require("../utilities/datetime");
var moment_1 = __importDefault(require("moment"));
var engagement_event_types_constant_1 = require("../constants/engagement-event-types.constant");
var constants_1 = require("../constants");
var services_1 = require("../generated/services");
var http_1 = require("@angular/common/http");
var entity_mail_history_source_1 = require("../constants/entity-mail-history-source");
var mail_format_1 = require("../constants/mail-format");
var http_interceptor_options_service_1 = require("./http/http-interceptor-options.service");
var core_1 = require("@ngx-translate/core");
var lodash_2 = __importDefault(require("lodash"));
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("../generated/services/activity-history-client.service"));
var i2 = __importStar(require("../generated/services/activity-client.service"));
var i3 = __importStar(require("../generated/services/entity-client.service"));
var i4 = __importStar(require("../generated/services/email-conversation-client.service"));
var i5 = __importStar(require("@angular/common/http"));
var i6 = __importStar(require("./http/http-interceptor-options.service"));
var i7 = __importStar(require("@ngx-translate/core"));
var ActivityService = /** @class */ (function () {
    function ActivityService(activityHistoriesClientService, activityClientService, entityClientService, emailConversationClientService, httpClient, httpInterceptorOptionsService, tService) {
        this.activityHistoriesClientService = activityHistoriesClientService;
        this.activityClientService = activityClientService;
        this.entityClientService = entityClientService;
        this.emailConversationClientService = emailConversationClientService;
        this.httpClient = httpClient;
        this.httpInterceptorOptionsService = httpInterceptorOptionsService;
        this.tService = tService;
        this.printedTemplatesPath = '/AlertDesk/DealSheet/ArchivedPdf?filePath=';
        this.emailTemplatePath = '/email/';
        this.emailTemplateSentPreviewParam = '&prev=1';
        this.apiActivityTypes = constants_1.ApiActivityTypes;
        this.activityTypes = constants_1.ActivityTypes;
        this.apiActivityStatuses = constants_1.ApiActivityStatuses;
        this.apiActivityActions = constants_1.ApiActivityActions;
        this.apiCrmActivityTypes = constants_1.ApiCrmActivityTypes;
        this.customerActivityTypes = constants_1.CustomerActivityTypes;
        this.settings = constants_1.Settings;
        this.emailFromTypes = constants_1.EmailFromTypes;
        this.customerProcessStatuses = constants_1.CustomerProcessStatuses;
        this.exportCampaignTypes = constants_1.ExportCampaignTypes;
    }
    ActivityService.prototype.runActivityRule = function (entityId, activityRules) {
        return this.activityClientService.RunActivityRulePOST({ entityId: entityId, activityRules: activityRules }).toPromise();
    };
    ActivityService.prototype.getActivities = function (opportunityId, dealerId, customerId) {
        var _this = this;
        var params = {
            opportunityId: opportunityId,
            dealerId: dealerId,
            customerId: customerId
        };
        return this.activityHistoriesClientService.GetCombinedActivityHistoryGET(params)
            .pipe(operators_1.map(function (response) { return _this.resolveActivities(response); })).toPromise();
    };
    ActivityService.prototype.resolveActivities = function (response) {
        var _this = this;
        var activityHistories = response.activityHistories || [];
        var templateOutputs = response.templateOutputs || [];
        var printOffers = response.printOffers || [];
        var oneToOneActivities = response.oneToOneActivities || [];
        var externalCrmData = response.externalCrmData || [];
        var emailConversations = response.emailConversations || [];
        var customerEngagements = response.customerEngagements || [];
        var customerActivities = response.customerActivities || [];
        var customerProcesses = response.customerProcesses || [];
        var exportHistories = response.exportHistories || [];
        var appraisalHistories = response.appraisalHistories || [];
        var dmsPushHistories = response.dmsPushHistories || [];
        var vinRecallActivities = response.vinRecallActivities || [];
        var textMessages = response.textMessages;
        var activities = [];
        var getFileUrlFromActivity = function (activity) {
            if (activity.templateOutboundEmailID) {
                return _this.settings.oidc.opportunitiesOrigin
                    + _this.emailTemplatePath
                    + activity.templateOutboundEmailID
                    + '?code='
                    + activity.accessCode
                    + _this.emailTemplateSentPreviewParam;
            }
        };
        /**
         * Adds /i to the end of a O2O URL so the tracking
         * counters don't count it as an open when we display it.
         */
        var ensureNonTrackingO2OUrl = function (url) {
            if (!url) // validate url is not empty/null or undefined
                return null;
            if (typeof url === 'string' && !url.endsWith('/i')) {
                return url + '/i';
            }
            return url;
        };
        for (var i = 0; i < exportHistories.length; i++) {
            var activity = exportHistories[i];
            var campaignTypeName = (lodash_2.default.invert(this.exportCampaignTypes))[activity.exportCampaignTypeID];
            var exportCampaignType = this.tService.instant('exportCampaignType_' + campaignTypeName);
            activities.push({
                type: this.activityTypes.export,
                submittedDateTime: new Date(activity.exportDate),
                submittedByUserFullName: activity.fullName,
                exportCampaignType: exportCampaignType,
                exportProvider: activity.providerName,
            });
        }
        for (var i = 0; i < activityHistories.length; i++) {
            var activity = activityHistories[i];
            if (activity.activityTypeID === this.apiActivityTypes.note ||
                activity.activityTypeID === this.apiActivityTypes.phoneCall ||
                activity.activityTypeID === this.apiActivityTypes.appointment ||
                activity.activityTypeID === this.apiActivityTypes.crm ||
                activity.activityTypeID === this.apiActivityTypes.email) {
                activities.push({
                    activityId: activity.activityID,
                    type: this.getActivityType(activity),
                    submittedByUserFullName: activity.insertUserFullName,
                    submittedDateTime: new Date(activity.insertDate),
                    notes: activity.notes,
                    result: activity.activityResultID,
                    scheduledDateTime: activity.dueDate && datetime_1.dateFromLocalString(activity.dueDate),
                    assignedUserFullName: activity.responsibleUserFullName,
                    assignedUserID: activity.responsibleUserID,
                    activityActionId: activity.activityActionID,
                    sendReminder: activity.sendReminder,
                    // --email template data
                    emailSubject: activity.emailSubject,
                    firstOpenDate: activity.firstOpenDate,
                    lastOpenDate: activity.lastOpenDate,
                    totalCount: activity.openCount,
                    recordingUrl: activity.recordingUrl || '',
                    fileUrl: getFileUrlFromActivity(activity),
                    activityHistoryStatusId: activity.activityStatusID,
                    activityStatusId: activity.activityActivityStatusID,
                    activityActionSubTypeID: activity.activityActionSubTypeID,
                    templateEmailId: activity.templateOutboundEmailID,
                    accessCode: activity.accessCode,
                    upgradeProposalIsAvailable: activity.upgradeProposalIsAvailable,
                });
            }
            if (activity.activityTypeID === this.apiActivityTypes.pandoProcess) {
                activities.push({
                    type: this.getActivityType(activity),
                    submittedDateTime: new Date(activity.insertDate),
                    notes: activity.notes,
                    assignedUserFullName: activity.responsibleUserFullName,
                    assignedUserID: activity.responsibleUserID,
                    activityId: activity.activityID,
                    activityActionId: activity.activityActionID,
                    activityHistoryStatusId: activity.activityStatusID,
                    activityStatusId: activity.activityActivityStatusID,
                    activityActionSubTypeID: activity.activityActionSubTypeID
                });
            }
        }
        for (var j = 0; j < templateOutputs.length; j++) {
            var template = templateOutputs[j];
            activities.push({
                type: this.activityTypes.printTemplate,
                submittedByUserFullName: template.fullName,
                submittedDateTime: new Date(template.generateDate),
                templateName: template.templateName,
                templateOutputId: template.templateOutputID,
                usesNewStorage: template.usesNewStorage,
                fileUrl: this.settings.legacy.iframeUrl + this.printedTemplatesPath + template.filePath
            });
        }
        for (var k = 0; k < printOffers.length; k++) {
            var printOffer = printOffers[k];
            activities.push({
                type: this.activityTypes.printOfferLetter,
                submittedByUserFullName: printOffer.generatedByUserFullName,
                submittedDateTime: new Date(printOffer.generateDate),
                fileUrl: printOffer.printUrl
            });
        }
        for (var l = 0; l < oneToOneActivities.length; l++) {
            var oneToOneActivity = oneToOneActivities[l];
            var oneToOneType = void 0;
            if (oneToOneActivity.sourceID == entity_mail_history_source_1.EntityMailHistorySource.NVQ
                || oneToOneActivity.sourceID == entity_mail_history_source_1.EntityMailHistorySource.One2One
                || oneToOneActivity.sourceID == entity_mail_history_source_1.EntityMailHistorySource.SKG) {
                // Filter One 2 One SourceID 1,2,3
                if (oneToOneActivity.mailFormatID === mail_format_1.MailFormat.Mail) {
                    oneToOneType = this.activityTypes.sendOneToOneMail;
                }
                else if (oneToOneActivity.mailFormatID === mail_format_1.MailFormat.Email) {
                    oneToOneType = this.activityTypes.sendOneToOneEmail;
                }
            }
            else if (oneToOneActivity.sourceID === entity_mail_history_source_1.EntityMailHistorySource.IntelligentMarketing) {
                // Filter Intelligent Marketing SourceID 4 is only IM
                if (oneToOneActivity.mailFormatID === mail_format_1.MailFormat.Mail) {
                    oneToOneType = this.activityTypes.sendIntelMrktMail;
                }
                else if (oneToOneActivity.mailFormatID === mail_format_1.MailFormat.Email) {
                    oneToOneType = this.activityTypes.sendIntelMrktEmail;
                }
            }
            else if ((oneToOneActivity.sourceID === entity_mail_history_source_1.EntityMailHistorySource.FordCreditMailers)) {
                // Filter SourceID 5 is Ford Credit Mailers => mail sent on a by-law rule to non O2O dealers (WEBUI-8901 & WEBUI-8902)
                oneToOneType = this.activityTypes.sendFordCreditMailers;
            }
            else if (oneToOneActivity.sourceID === entity_mail_history_source_1.EntityMailHistorySource.ServiceMarketing) {
                if (oneToOneActivity.mailFormatID === mail_format_1.MailFormat.Mail) {
                    oneToOneType = this.activityTypes.sendServiceMarketingMail;
                }
                else if (oneToOneActivity.mailFormatID === mail_format_1.MailFormat.Email) {
                    oneToOneType = this.activityTypes.sendServiceMarketingEmail;
                }
                oneToOneActivity.pUrl = null; // WEBUI-9831 SM should not display a pUrl link
            }
            else if (oneToOneActivity.sourceID === entity_mail_history_source_1.EntityMailHistorySource.SLM) {
                if (oneToOneActivity.mailFormatID === mail_format_1.MailFormat.Mail) {
                    continue;
                }
                else if (oneToOneActivity.mailFormatID === mail_format_1.MailFormat.Email) {
                    oneToOneType = this.activityTypes.sentSLMEmailOffer;
                }
            }
            else if (oneToOneActivity.sourceID === entity_mail_history_source_1.EntityMailHistorySource.PartnerExport) {
                if (oneToOneActivity.mailFormatID === mail_format_1.MailFormat.Email) {
                    continue;
                }
                else if (oneToOneActivity.mailFormatID === mail_format_1.MailFormat.Mail) {
                    oneToOneType = this.activityTypes.sendPartnerExportMail;
                    // For now we are stuffing Parter Export only data into the pUrl field
                    if (oneToOneActivity.pUrl != null) {
                        var strArray = oneToOneActivity.pUrl.split("|");
                        if (strArray.length == 2) {
                            oneToOneActivity.preferredPartner = strArray[0];
                            oneToOneActivity.messageCreativeType = strArray[1];
                        }
                    }
                    oneToOneActivity.pUrl = null; // WEBUI-10324 Partner Export does not display a pUrl link
                }
            }
            activities.push({
                type: oneToOneType,
                submittedDateTime: oneToOneActivity.utcDateSent ? new Date(oneToOneActivity.utcDateSent) : null,
                oneToOneKey: oneToOneActivity.mailServiceProviderID + '_' + oneToOneActivity.mailFormatID + '_' + oneToOneActivity.mailCode,
                pUrl: oneToOneType == this.activityTypes.sendPartnerExportMail ? oneToOneActivity.pUrl : ensureNonTrackingO2OUrl(oneToOneActivity.pUrl),
                preferredPartner: oneToOneActivity.preferredPartner,
                additionalData: oneToOneActivity.messageCreativeType ? this.tService.instant("partnerExportMessage", { messageCreativeType: oneToOneActivity.messageCreativeType }) : null
            });
        }
        for (var p = 0; p < customerProcesses.length; p++) {
            var customerProcess = customerProcesses[p];
            var processStatusCodeName = (lodash_2.default.invert(this.customerProcessStatuses))[customerProcess.status];
            var status_1 = this.tService.instant('customerProcessStatus_' + processStatusCodeName);
            activities.push({
                type: this.activityTypes.customerPandoProcess,
                submittedDateTime: customerProcess.startDateUtc ? new Date(customerProcess.startDateUtc) : null,
                templateName: customerProcess.processTemplateName,
                processTitle: customerProcess.processTitle,
                submittedByUserFullName: customerProcess.requestorFirstLast,
                assignedUserFullName: customerProcess.lastAssignedToFirstLast,
                requestorAvatarUrl: customerProcess.requestorAvatarUrl,
                lastAssignedToAvatarUrl: customerProcess.lastAssignedToAvatarUrl,
                customerProcessStatus: status_1,
                customerProcessStatusCode: customerProcess.status,
                elapsedSeconds: customerProcess.elapsedSeconds,
                lastActivityDateTime: customerProcess.lastActivityDateUtc
            });
        }
        // customer activities (handle autoAssistCustomerReplied events separately)
        customerActivities.forEach(function (custActivity) {
            var typeId = -1;
            switch (custActivity.customerActivityEventID) {
                case _this.customerActivityTypes.autoAssistCommSent:
                    typeId = _this.activityTypes.autoAssistCommSent;
                    break;
                case _this.customerActivityTypes.autoAssistNewHotLead:
                    typeId = _this.activityTypes.autoAssistNewHotLead;
                    break;
                case _this.customerActivityTypes.geoAlertActive:
                    typeId = _this.activityTypes.geoAlertActive;
                    break;
                case _this.customerActivityTypes.geoAlertCampaign:
                    typeId = _this.activityTypes.geoAlertCampaign;
                    break;
                case _this.customerActivityTypes.geoAlertAd:
                    typeId = _this.activityTypes.geoAlertAd;
                    break;
                case _this.customerActivityTypes.facebookAdded:
                    typeId = _this.activityTypes.facebookAdded;
                    break;
                case _this.customerActivityTypes.facebookVerified:
                    typeId = _this.activityTypes.facebookVerified;
                    break;
                case _this.customerActivityTypes.autofiDigitalRetailing:
                    typeId = _this.activityTypes.autofiDigitalRetailing;
                    break;
                case _this.customerActivityTypes.autofiDigitalRetailingCreditApp:
                    typeId = _this.activityTypes.autofiDigitalRetailingCreditApp;
                    break;
                case _this.customerActivityTypes.autofiDigitalRetailingApptSched:
                    typeId = _this.activityTypes.autofiDigitalRetailingApptSched;
                    break;
            }
            if (typeId !== -1) {
                activities.push({
                    type: typeId,
                    submittedDateTime: new Date(custActivity.activityDateUTC),
                    messageText: custActivity.eventDetails,
                });
            }
        });
        // AutoAssist autoAssistCustomerReplied activities
        var autoAssistActivities = customerActivities
            .filter(function (custActivity) { return custActivity.customerActivityEventID === _this.customerActivityTypes.autoAssistCustomerReplied; })
            .map(function (custActivity) { return ({
            activityDateUTC: custActivity.activityDateUTC,
            campaignId: custActivity.campaignID,
            eventDetails: custActivity.eventDetails
        }); });
        var activitiesByCampaign = lodash_1.groupBy(autoAssistActivities, function (act) {
            return act.campaignId;
        });
        for (var _i = 0, _a = Object.entries(activitiesByCampaign); _i < _a.length; _i++) {
            var _b = _a[_i], campaignId = _b[0], activitesPerCampaign = _b[1];
            activitesPerCampaign.sort(function (activity1, activity2) {
                var time1 = moment_1.default.utc(activity1.activityDateUTC, 'YYYY-MM-DD[T]HH:mm[Z]');
                var time2 = moment_1.default.utc(activity2.activityDateUTC, 'YYYY-MM-DD[T]HH:mm[Z]');
                var isAfter = time2.isAfter(time1);
                return isAfter ? 1 : -1;
            });
            activities.push({
                type: this.activityTypes.autoAssistCustomerReplied,
                // Take the most recent event
                submittedDateTime: new Date(activitesPerCampaign[0].activityDateUTC),
                messageText: activitesPerCampaign[0].eventDetails
            });
        }
        var ungroupedctivities = customerEngagements
            .map(function (engagement) {
            switch (engagement.engagementEventTypeID) {
                case engagement_event_types_constant_1.EngagementEventTypes.purlView:
                    return {
                        type: _this.activityTypes.purlView,
                        submittedDateTime: engagement.eventDateUTC ? new Date(engagement.eventDateUTC) : null,
                        pUrl: ensureNonTrackingO2OUrl(engagement.purl),
                    };
                case engagement_event_types_constant_1.EngagementEventTypes.purlViewIM:
                    return {
                        type: _this.activityTypes.purlViewIntelMrkt,
                        submittedDateTime: engagement.eventDateUTC ? new Date(engagement.eventDateUTC) : null,
                        pUrl: ensureNonTrackingO2OUrl(engagement.purl),
                    };
                case engagement_event_types_constant_1.EngagementEventTypes.purlLeadSubmission:
                    return {
                        type: _this.activityTypes.purlSubmit,
                        submittedDateTime: engagement.eventDateUTC ? new Date(engagement.eventDateUTC) : null,
                        pUrl: ensureNonTrackingO2OUrl(engagement.purl),
                    };
                case engagement_event_types_constant_1.EngagementEventTypes.purlLeadSubmissionIM:
                    return {
                        type: _this.activityTypes.purlSubmitIntelMrkt,
                        submittedDateTime: engagement.eventDateUTC ? new Date(engagement.eventDateUTC) : null,
                        pUrl: ensureNonTrackingO2OUrl(engagement.purl),
                    };
                case engagement_event_types_constant_1.EngagementEventTypes.onlineServiceReview:
                    return {
                        type: _this.activityTypes.reviewProServiceRating,
                        submittedDateTime: engagement.eventDateUTC ? new Date(engagement.eventDateUTC) : null,
                        pUrl: engagement.purl,
                        reviewRating: engagement.reviewRating
                    };
                case engagement_event_types_constant_1.EngagementEventTypes.onlineSalesReview:
                    return {
                        type: _this.activityTypes.reviewProSalesRating,
                        submittedDateTime: engagement.eventDateUTC ? new Date(engagement.eventDateUTC) : null,
                        pUrl: engagement.purl,
                        reviewRating: engagement.reviewRating
                    };
            }
        })
            .filter(function (item) { return item !== undefined; });
        activities.push.apply(activities, ungroupedctivities);
        // websiteEngaged
        var webEngagementActivities = (function () {
            var viewDates = customerEngagements
                .filter(function (engagement) { return engagement.engagementEventTypeID === engagement_event_types_constant_1.EngagementEventTypes.websiteEngaged; })
                .map(function (engagement) { return ({
                eventDateUTC: engagement.eventDateUTC ? datetime_1.dateFromUtcString(engagement.eventDateUTC) : null,
                notes: engagement.notes,
                purl: engagement.purl
            }); });
            // Group the website engagements by day, then return the
            // total number of views
            var grouped = lodash_1.groupBy(viewDates, function (date) { return date.eventDateUTC ? date.eventDateUTC.toDateString() : null; });
            return Object.entries(grouped)
                .map(function (_a) {
                var day = _a[0], dates = _a[1];
                var datesArray = dates.map(function (d) {
                    return d.eventDateUTC;
                });
                var firstViewedDate = datesArray.reduce(function (acc, d) { return acc < d ? acc : d; });
                var lastViewedDate = datesArray.reduce(function (acc, d) { return acc > d ? acc : d; });
                return {
                    type: _this.activityTypes.websiteEngaged,
                    submittedDateTime: lastViewedDate,
                    firstViewedDate: firstViewedDate,
                    lastViewedDate: lastViewedDate,
                    viewCount: dates.length,
                    items: dates
                };
            });
        })();
        activities.push.apply(activities, webEngagementActivities);
        // website lead submission
        var webLeadSubmissionActivities = customerEngagements
            .filter(function (engagement) { return engagement.engagementEventTypeID === engagement_event_types_constant_1.EngagementEventTypes.websiteLeadSubmission; })
            .map(function (engagement) { return ({
            type: _this.activityTypes.websiteLeadSubmission,
            submittedDateTime: engagement.eventDateUTC ? datetime_1.dateFromUtcString(engagement.eventDateUTC) : null,
        }); });
        activities.push.apply(activities, webLeadSubmissionActivities);
        if (externalCrmData) {
            for (var n = 0; n < externalCrmData.length; n++) {
                var template = externalCrmData[n];
                activities.push({
                    type: this.getExternalActivityType(template.activityType + ''),
                    submittedByUserFullName: template.performedByFullName,
                    submittedDateTime: template.activityDate ? new Date(template.activityDate) : null,
                    emailSubject: template.subject,
                    emailTo: template.toEmailAddress,
                    emailFrom: template.fromEmailAddress,
                    notes: template.notes,
                    contactPhone: template.contactedPhone,
                });
            }
        }
        for (var p = 0; p < emailConversations.length; p++) {
            var emailConversation = emailConversations[p];
            var emailConversationType = void 0;
            var emailConversationSubmittedBy = void 0;
            if (emailConversation.emailFrom === this.emailFromTypes.None) {
                emailConversationType = this.activityTypes.emailReply;
                emailConversationSubmittedBy = emailConversation.fromName;
            }
            else if (emailConversation.emailFrom === this.emailFromTypes.Customer) {
                emailConversationType = this.activityTypes.emailReplyCustomer;
                emailConversationSubmittedBy = emailConversation.customerName;
            }
            else if (emailConversation.emailFrom === this.emailFromTypes.User) {
                emailConversationType = this.activityTypes.emailReplyDealer;
                emailConversationSubmittedBy = emailConversation.userFullName;
            }
            activities.push({
                type: emailConversationType,
                emailConversationItemId: emailConversation.emailConversationItemId,
                submittedByUserFullName: emailConversationSubmittedBy,
                emailConversationSubject: emailConversation.subject,
                submittedDateTime: new Date(emailConversation.sentDateTime),
                firstOpenDate: emailConversation.emailFirstOpenedDateTime,
                lastOpenDate: emailConversation.emailLastOpenedDateTime,
                totalCount: emailConversation.emailOpenCount
            });
        }
        // Appraisals
        for (var r = 0; r < appraisalHistories.length; r++) {
            var appraisalHistory = appraisalHistories[r];
            activities.push({
                type: this.activityTypes.appraisal,
                appraisalId: appraisalHistory.appraisalID,
                appraisalUrl: appraisalHistory.appraisalLink,
                appraisalHistoryTypeId: appraisalHistory.appraisalHistoryTypeID,
                submittedByUserFullName: appraisalHistory.fullName,
                submittedDateTime: new Date(appraisalHistory.insertDateUTC),
            });
        }
        // Dms push activites
        for (var r = 0; r < dmsPushHistories.length; r++) {
            var dmsPushHistory = dmsPushHistories[r];
            activities.push({
                type: this.activityTypes.dmsPush,
                dmsCustomerId: dmsPushHistory.dmsCustomerId,
                dmsDealId: dmsPushHistory.dmsDealId,
                submittedByUserFullName: dmsPushHistory.fullName,
                submittedDateTime: new Date(dmsPushHistory.createDateUtc),
                dmsRequestTypeId: dmsPushHistory.requestTypeId
            });
        }
        // VinRecall activities
        for (var r = 0; r < vinRecallActivities.length; r++) {
            var vinRecallActivity = vinRecallActivities[r];
            var notes = 'Recall status for VIN ' + vinRecallActivity.vin + ' changed, ' + vinRecallActivity.changeTypeName;
            if (vinRecallActivity.notes) {
                notes = notes + ': ' + vinRecallActivity.notes;
            }
            activities.push({
                type: this.activityTypes.vinRecall,
                submittedDateTime: new Date(vinRecallActivity.changeDateTime),
                notes: notes
            });
        }
        // Text messages
        var textMessagesByDay = lodash_1.groupBy(textMessages, function (tm) {
            return moment_1.default(tm.sentDateTime).startOf('day') + "|{" + tm.dealerPhoneAccessRightID;
        });
        for (var _c = 0, _d = Object.entries(textMessagesByDay); _c < _d.length; _c++) {
            var _e = _d[_c], groupKey = _e[0], textMessagesPerDay = _e[1];
            textMessagesPerDay = textMessagesPerDay.sort(function (textMessage1, textMessage2) {
                var isAfter = moment_1.default(textMessage2.sentDateTime).isAfter(textMessage1.sentDateTime);
                return isAfter ? -1 : 1;
            });
            activities.push({
                activityId: textMessagesPerDay[0].messageId,
                type: this.activityTypes.textMessage,
                // We take the latest text message so that the activity will show up in the right place in the activity list
                submittedDateTime: new Date(textMessagesPerDay[0].sentDateTime),
                textMessages: textMessagesPerDay
            });
        }
        var bySubmittedDateTime = function (activity1, activity2) {
            var time2 = new Date(activity2.submittedDateTime || activity2.submittedDate).getTime();
            var time1 = new Date(activity1.submittedDateTime || activity1.submittedDate).getTime();
            return time2 - time1;
        };
        activities.sort(bySubmittedDateTime);
        return activities;
    };
    ActivityService.prototype.getLastActivityDetails = function (opportunityId) {
        return this.activityHistoriesClientService.GetLastActivityByEntityIdByEntityidGET(opportunityId).toPromise();
    };
    ActivityService.prototype.getAgendaItems = function (selectedDealerId, take, flushCache) {
        var params = {};
        params.flushCache = flushCache;
        params.take = take;
        if (selectedDealerId !== null && selectedDealerId !== undefined) {
            this.httpInterceptorOptionsService.setOverrideDealerIds([selectedDealerId]);
        }
        return this.activityClientService.GetAgendaItemsGET(params).toPromise();
    };
    ActivityService.prototype.getAgendaItemsWithEntityData = function (params) {
        return this.activityClientService.GetAgendaItemsWithEntityDataGET(params).toPromise();
    };
    ActivityService.prototype.postActivitySubmitAction = function (activity) {
        return this.activityClientService.SubmitActionPOST(activity).toPromise();
    };
    ActivityService.prototype.updateWarrantyStatus = function (opportunityId) {
        return this.entityClientService.HasWarrantyByEntityidPOST(opportunityId).toPromise();
    };
    ActivityService.prototype.updateSoldWarranty = function (opportunityId) {
        return this.entityClientService.SoldWarrantyByEntityidPOST(opportunityId).toPromise();
    };
    ActivityService.prototype.updateCustomerDoesNotOwnVehicle = function (opportunityId) {
        return this.entityClientService.CustomerDoesNotOwnVehicleByEntityidPOST(opportunityId).toPromise();
    };
    ActivityService.prototype.updateVehiclePaidOff = function (opportunityId) {
        return this.entityClientService.VehiclePaidOffByEntityidPOST(opportunityId).toPromise();
    };
    ActivityService.prototype.updateVehiclePurchasedByDealer = function (opportunityId) {
        return this.entityClientService.VehiclePurchasedByDealerByEntityidPOST(opportunityId).toPromise();
    };
    ActivityService.prototype.getEmailConversation = function (emailConversationItemId) {
        return this.emailConversationClientService.GetEmailBodyByIdGET(emailConversationItemId).toPromise();
    };
    ActivityService.prototype.getActivityType = function (activity) {
        if (activity.activityTypeID === constants_1.ApiActivityTypes.phoneCall) {
            var type = this.activityTypes.logPhoneCall;
            switch (activity.activityStatusID) {
                case this.apiActivityStatuses.scheduled:
                    type = this.activityTypes.schedulePhoneCall;
                    break;
                case this.apiActivityStatuses.completed:
                    type = activity.dueDate ? this.activityTypes.completePhoneCall : this.activityTypes.logPhoneCall;
                    break;
                case this.apiActivityStatuses.uncompleted:
                    type = this.activityTypes.expirePhoneCall;
                    break;
            }
            switch (activity.activityActionID) {
                case this.apiActivityActions.reschedulePhoneCall:
                    type = this.activityTypes.reschedulePhoneCall;
                    break;
                case this.apiActivityActions.reassignPhoneCall:
                    type = this.activityTypes.reassignPhoneCall;
                    break;
                case this.apiActivityActions.cancelPhoneCall:
                    type = this.activityTypes.cancelPhoneCall;
                    break;
            }
            return type;
        }
        if (activity.activityTypeID === constants_1.ApiActivityTypes.appointment) {
            var type = this.activityTypes.scheduleAppointment;
            switch (activity.activityStatusID) {
                case this.apiActivityStatuses.completed:
                    type = this.activityTypes.completeAppointment;
                    break;
                case this.apiActivityStatuses.uncompleted:
                    type = this.activityTypes.expireAppointment;
                    break;
            }
            switch (activity.activityActionID) {
                case this.apiActivityActions.rescheduleAppointment:
                    type = this.activityTypes.rescheduleAppointment;
                    break;
                case this.apiActivityActions.reassignAppointment:
                    type = this.activityTypes.reassignAppointment;
                    break;
                case this.apiActivityActions.cancelAppointment:
                    type = this.activityTypes.cancelAppointment;
                    break;
            }
            return type;
        }
        if (activity.activityTypeID === constants_1.ApiActivityTypes.crm) {
            return this.activityTypes.pushToCrm;
        }
        if (activity.activityTypeID === constants_1.ApiActivityTypes.email) {
            var type = void 0;
            switch (activity.activityActionID) {
                case this.apiActivityActions.sendEmailTemplate:
                    type = this.activityTypes.sendEmailTemplate;
                    break;
                case this.apiActivityActions.sendEmail:
                    type = this.activityTypes.sendEmail;
                    break;
            }
            return type;
        }
        if (activity.activityTypeID === constants_1.ApiActivityTypes.pandoProcess) {
            return this.activityTypes.pandoProcess;
        }
        return activity.activityTypeID;
    };
    ActivityService.prototype.getExternalActivityType = function (key) {
        key = key.toLowerCase();
        var resultType = -1;
        switch (key) {
            case this.apiCrmActivityTypes.beBack:
                resultType = this.activityTypes.logCrmCustomerWillBeBack;
                break;
            case this.apiCrmActivityTypes.inboundCall:
                resultType = this.activityTypes.logCrmInboundCall;
                break;
            case this.apiCrmActivityTypes.inboundEmail:
                resultType = this.activityTypes.logCrmInboundEmail;
                break;
            case this.apiCrmActivityTypes.letter:
                resultType = this.activityTypes.sendCrmLetter;
                break;
            case this.apiCrmActivityTypes.outboundCall:
                resultType = this.activityTypes.logCrmOutboundCall;
                break;
            case this.apiCrmActivityTypes.outboundEmail:
                resultType = this.activityTypes.logCrmOutboundEmail;
                break;
            case this.apiCrmActivityTypes.prospectAlert:
                resultType = this.activityTypes.logCrmProspectAlert;
                break;
            case this.apiCrmActivityTypes.prospectStatus:
                resultType = this.activityTypes.logCrmProspectStatus;
                break;
            case this.apiCrmActivityTypes.remark:
                resultType = this.activityTypes.logCrmRemark;
                break;
            case this.apiCrmActivityTypes.remarkShowroom:
                resultType = this.activityTypes.logCrmShowroomRemark;
                break;
            case this.apiCrmActivityTypes.reminder:
                resultType = this.activityTypes.sendCrmReminder;
                break;
            case this.apiCrmActivityTypes.textMessage:
                resultType = this.activityTypes.sendCrmTextMessage;
                break;
            case this.apiCrmActivityTypes.inboundTextMessage:
                resultType = this.activityTypes.crmInboundTextMessage;
                break;
            case this.apiCrmActivityTypes.outboundTextMessage:
                resultType = this.activityTypes.crmOutboundTextMessage;
                break;
        }
        return resultType;
    };
    ActivityService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ActivityService_Factory() { return new ActivityService(i0.ɵɵinject(i1.ActivityHistoryClientService), i0.ɵɵinject(i2.ActivityClientService), i0.ɵɵinject(i3.EntityClientService), i0.ɵɵinject(i4.EmailConversationClientService), i0.ɵɵinject(i5.HttpClient), i0.ɵɵinject(i6.HttpInterceptorOptionsService), i0.ɵɵinject(i7.TranslateService)); }, token: ActivityService, providedIn: "root" });
    return ActivityService;
}());
exports.ActivityService = ActivityService;
